export default "__VITE_ASSET__Bfhqzqmu__"